import { useEffect } from 'react';
import { useMapContext, useOverlayContext } from 'shared/context';
import { useHexGeneration, useWindowSize } from 'shared/hooks';
import { GRID, HEX, MAP } from 'shared/constants';

export const useGrid = () => {
  const { map } = useMapContext();
  const { ctx, setScale } = useOverlayContext();
  const [windowWidth, windowHeight] = useWindowSize();
  const { generateHexGrid } = useHexGeneration();

  const clearGrid = () =>
    ctx?.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

  const updateGrid = (zoom: number, scale: number) => {
    if (!map) return;
    clearGrid();
    const centerWorldPoint = map.latLngToContainerPoint([0, 0]);

    if (zoom >= GRID.MAX_ZOOM) {
      const hexWidth = HEX.WIDTH * scale;
      const hexCenterX = hexWidth / 2;
      const hexCenterY = hexWidth / 2;
      const fixedOffsetX = (centerWorldPoint.x / 2) % hexWidth;
      const fixedOffsetY = (centerWorldPoint.y / 2) % ((3 / 2) * hexWidth);
      const offsetX = hexCenterX - fixedOffsetX;
      const offsetY = hexCenterY - fixedOffsetY;
      generateHexGrid(offsetX, offsetY, scale);
    }
  };

  const updateGridOnWindowResize = () => {
    if (!ctx) return;
    ctx.canvas.width = windowWidth;
    ctx.canvas.height = windowHeight;
    handleGridChange();
  };

  const handleGridChange = () => {
    if (!map) return;
    const zoom = map.getZoom();
    const scale = map.getZoomScale(zoom, MAP.ZOOM);
    setScale(scale);
    updateGrid(zoom, scale);
  };

  useEffect(() => {
    updateGridOnWindowResize();
  }, [windowWidth, windowHeight]);

  return { handleGridChange };
};
